module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_an-f43912c1f038f41c03ad43895f90eec7.jpg";